'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'box-taped';
var width = 448;
var height = 512;
var aliases = ["box-alt"];
var unicode = 'f49a';
var svgPathData = 'M288 176l0 48c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-48-112 0 0 240c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-240-112 0zm0-48l101 0-40.9-57.3c-3-4.2-7.9-6.7-13-6.7l-68.4 0 21.3 64zM181.3 64l-68.4 0c-5.2 0-10 2.5-13 6.7L59 128 160 128 181.3 64zM0 148.5c0-13.3 4.2-26.3 11.9-37.2L60.9 42.8C72.9 26 92.3 16 112.9 16l222.1 0c20.7 0 40.1 10 52.1 26.8l48.9 68.5c7.8 10.9 11.9 23.9 11.9 37.2L448 416c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 148.5z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBoxTaped = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;